import sortBy from 'lodash/sortBy';
import type {ManifestationV4} from '../types';

export const sortManifestations = (
  manifestations: ManifestationV4[],
): ManifestationV4[] => {
  return sortBy(manifestations, [m => -(m.publishedYear ?? -10000)]);
};
